import { render, staticRenderFns } from "./ServiceOrderPage.vue?vue&type=template&id=3516225a&"
import script from "./ServiceOrderPage.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports